const largeMinWidth = 990;

function centerItems() {
    const screenWidth = window.innerWidth;
    if (screenWidth < largeMinWidth) {
        return;
    }

    const carousel = document.querySelector(".thumbnail-list.list-unstyled.slider.slider--mobile");
    if (!carousel) {
        return;
    }

    const parentContainer = document.querySelector(".product");
    if (!parentContainer) {
        return;
    }

    let expectedColumns = 4;
    if (parentContainer.classList.contains("product--medium")) {
        expectedColumns = 5;
    }
    if (parentContainer.classList.contains("product--large")) {
        expectedColumns = 6;
    }

    if (carousel.children.length >= expectedColumns) {
        return;
    }

    carousel.style.gridTemplateColumns = `repeat(${carousel.children.length}, minmax(100px, 150px))`;
    carousel.style.justifyContent = "center";
}

centerItems()